import React from 'react';
import s from './styles.module.css';
import imageUrl from '../../../../assets/no_data.svg';

const ReportError = () => (
  <div className={s.errorContainer}>
    <main className={s.content}>
      <img
        src={imageUrl}
        className={s.picture}
        role="presentation"
      />
      <h1 className={s.title}>Data Not Loaded</h1>
      <p className={s.description}>
        We haven&#39;t been able to collect all the data needed for this report.
        <br />
        Please try <button className={s.link} onClick={() => window.location.reload(false)}>refreshing the page</button>.
      </p>
    </main>
  </div>
);

export default ReportError;
